import React from "react";
import GraphTemplateEPROsB from "../../graphs/GraphTemplateEPROsB";
// import GraphTemplateEPROsA from "./src/graphs/GraphTemplateEPROsA";

// import GraphTemplateEPROsA from "../../graphs/GraphTemplateEPROsA";
import AnotherReportsListSidebar004B from "./AnotherReportsListSidebar004B";

import AdminNavbar from "../../components/AdminNavbar";import {Col, Container, Row} from "react-bootstrap";

const B004CPAQ8PWgraphs = () => {
  return (
    <>
      <AdminNavbar />
      <AnotherReportsListSidebar004B/>
      <Container fluid={true} >
        <div className="mt-4">
        <div className="article">
          <div className="TitleC">Chronic Pain Acceptance 8, Pain Willingness Scale</div>
          <p className="TitleDB" style={{paddingTop: "5px"}} >cpaq8PW goal: -</p>
          
          <Row>
            <Col xs={10}>
            <div className="TitleDB" style={{paddingBottom:"8px", paddingTop: "25px"}}>ACT Daily</div>
              <GraphTemplateEPROsB report={"ACT_cpaq8PW004Bdaily"} />
            </Col>
          </Row>
        
 <Row>
            <Col xs={10}>
            <div className="TitleDB" style={{paddingBottom:"8px", paddingTop: "20px"}}>ACT Weekly</div>
              <GraphTemplateEPROsB report={"ACT_cpaq8PW004Bweekly"} />
            </Col>
          </Row>

          <Row>
            <Col xs={10}>
            <div className="TitleDB" style={{paddingBottom:"8px", paddingTop: "20px"}}>ST</div>
              <GraphTemplateEPROsB report={"ST_cpaq8PW004B"} />
            </Col>
          </Row>

          

          </div>
        </div>
      </Container>
    </>
  );
};

export default B004CPAQ8PWgraphs;

